/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Wizard_Step4_Select_Member_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Select a member to add" |
*
* @param {Spaces_Wizard_Step4_Select_Member_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_wizard_step4_select_member_placeholder = /** @type {((inputs?: Spaces_Wizard_Step4_Select_Member_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Wizard_Step4_Select_Member_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wähle ein Mitglied zum Hinzufügen")
	return /** @type {LocalizedString} */ ("Select a member to add")
});